import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainApi } from '@/lib/api';
import { QUERY_KEYS, StoreType } from '@/lib/constants';
import { stanNotify } from '@/lib/stanNotify';

/**
 * Upgrade a legacy funnel to the new store theme. Clears the funnel's
 * custom `primary_color`/`secondary_color` so it inherits from the user's
 * linksite store.
 */
export function useUpgradeFunnelTheme(storeId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            await mainApi.put(`v1/stores/${storeId}/change-theme`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FUNNELS, 'detail', storeId] });
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.STORE_DATA, StoreType.FUNNEL] });
            stanNotify({
                type: 'success',
                title: 'Saved!',
                text: 'Your funnel has been upgraded to your store theme.',
            });
        },
        onError: () => {
            stanNotify({
                type: 'error',
                title: 'Oops.',
                text: 'Something went wrong. Please try again later.',
            });
        },
    });
}
